import React from 'react';
import {
  deluxeProps,
  topMatchProps,
} from '../../Templates/Assessment/Assessment';
import { FormattedMessage } from 'react-intl';
import messages from 'src/apps/maas360-estimator/locales/messages';
import Deluxe from '../Deluxe/Deluxe';

type packageDataProps = {
  data: topMatchProps;
  deluxe: boolean;
  deluxeData: deluxeProps;
  noAdditionalReq: boolean;
};

const PackageDetail = ({
  data,
  deluxe,
  deluxeData,
  noAdditionalReq,
}: packageDataProps) => {
  return (
    <div>
      <div className="page_sub_heading_2 ibm-mb-1">{data.title}</div>
      <span className="page_sub_heading_2 mar2">{data.plan}</span>{' '}
      <span className="page_body mar2">{data.desc}</span>
      <div className="margin-top">
        <span className="price_table_comp__bodycopy">
          <FormattedMessage {...messages.start_at} />
        </span>
        <span className="page_heading_3">{data.price}*</span>
        <div className="tax_text">
          *<FormattedMessage {...messages.tax_info} />
        </div>
        {deluxe && (
          <Deluxe data={deluxeData} noAdditionalReq={noAdditionalReq} />
        )}
      </div>
    </div>
  );
};

export default PackageDetail;
